module.exports = __webpack_public_path__ + "img/1.e3e746f8.jpg";